module.exports={
	"Form": "PhysicalAssetDefectCreateManifest",
	"Scope": "PhysicalAssetDefect-Create",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Create-Identity",
				"Group": "PhysicalAssetDefect-Create-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-Identity",
				"Group": "PhysicalAssetDefect-Create-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-Create-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-Create-Details",
				"Group": "PhysicalAssetDefect-Create-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-Create-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-Create-ConditionStates",
				"Group": "PhysicalAssetDefect-Create-ConditionStates"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-Create-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-Create-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
